import React, { useEffect, useState } from "react";
import { useLevageHistoryMaterialStore } from "./store/LevageHistoryStore";
import { MaterialService } from "./core/_request";
import { HttpStatusCode } from "axios";
import { ColumnItem } from "../../common/models/table";
import { LFTableV3 } from "../../common/components/LFTable/LFTableV3";
import { Loader } from "../../common/components/Loader/Loader";
import { ActionsKey } from "../../common/models/Actions";
import { CustomDrawer } from "../../common/components/Drawer/CustomDrawer";
import { LevageHistoryDetails } from "./LevageHistoryDetails";

type PropsType = {
  isShowDrawer: boolean;
  onShowDrawerHandler: () => void;
};

export const LevageHistoryList = ({
  isShowDrawer,
  onShowDrawerHandler,
}: PropsType) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const {
    levageMaterialList,
    setLevageHistoryMaterialList,
    totalItems,
    actioned,
    setActioned,
    pageState,
    setPageState,
    resetPageState,
  } = useLevageHistoryMaterialStore();

  const cols: ColumnItem[] = [
    {
      key: "material",
      title: "Référence",
      dataIndex: "material",
      show: true,
      searchType: "text",
      nestedKey: "material",
      searchKey: "material.reference",
      render: (state: any) => {
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <span>{state?.reference}</span>
          </div>
        );
      },
    },
    {
      key: "operation",
      title: "Opération ",
      dataIndex: "operation",
      searchType: "text",
      nestedKey: "operation",
      searchKey: "operation.reference",
      show: true,
      render: (state: any) => {
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <span>{state?.reference ?? "-"}</span>
          </div>
        );
      },
    },
    {
      key: "movementType",
      title: "Type de mouvement ",
      dataIndex: "movementType",
      show: true,
      render: (state: any) => {
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <span>{state?.name ?? "-"}</span>
          </div>
        );
      },
    },
    {
      key: "quantityTxt",
      title: "Quantité ",
      dataIndex: "quantityTxt",
      show: true,
    },

    {
      key: "checkedBy",
      title: "Fait par",
      dataIndex: "checkedBy",
      show: true,

      render: (state: any) => {
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            {" "}
            {state?.fullname ?? "-"}{" "}
          </div>
        );
      },
    },
    {
      key: "createdAt",
      title: "Date",
      dataIndex: "createdAt",
      show: true,
    },
  ];

  useEffect(() => {
    fetchAllMaterialLevageHistory(pageState);
  }, [pageState]);

  const fetchAllMaterialLevageHistory = async (params?: any) => {
    try {
      setIsLoading(true);
      const res = await MaterialService.getLevageMaterialHistoryList(params);
      if (res?.status === HttpStatusCode.Ok) {
        setLevageHistoryMaterialList(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSetParams = (params: any) => {
    setPageState({
      ...params,
    });
  };

  const onActionClick = (item: any, action: ActionsKey) => {
    if (action === "delete") {
      console.log(item?.id);
    } else {
      getOne(item?.id, action);
    }
  };

  const getOne = async (id: number, action: any) => {
    try {
      setIsLoading(true);
      const res = await MaterialService.getOneLevageMaterialHistory(id);
      if (res?.status === HttpStatusCode.Ok) {
        setActioned({
          data: {
            ...res?.data,
          },
          action,
        });
      }
      onShowDrawerHandler();
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className="">
      <Loader isLoading={isLoading} />

      <LFTableV3
        columns={cols}
        data={levageMaterialList}
        params={pageState}
        onAction={onActionClick}
        isCanEdit={() => false}
        isCanDelete={() => false}
        isCanShow={() => true}
        onSearch={handleSetParams}
        onSort={handleSetParams}
        onResetSearch={resetPageState}
        pagination={{
          defaultCurrentPage: pageState.page,
          itemsPerPage: pageState?.itemsPerPage,
          totalItems: totalItems,
        }}
        onChangePage={handleSetParams}
      />

      {isShowDrawer ? (
        <CustomDrawer
          isOpen={isShowDrawer}
          onClose={onShowDrawerHandler}
          title={actioned?.action === "read" ? "Détails" : ""}
          width={"75%"}
        >
          <LevageHistoryDetails
            {...(actioned?.action === "read"
              ? {
                  initialValue: actioned?.data,
                }
              : {})}
          />
        </CustomDrawer>
      ) : (
        ""
      )}
    </div>
  );
};
